export const MESSAGE_FORM_DEFAULT_VALUES = {
  isNoteOption: true,
  isSMSOption: false,
  isEmailOption: false,
  isLetterOption: false,
  isCPNoteOption: false,
  isDPNoteOption: false,
};

export enum StorageType {
  BLOB = "BlobStorage",
  LOCAL = "LocalStorage",
}

export const UPLOAD_RULES_INITIAL_VALUES = {
  entityId: -1,
  type: "BU",
  propertyList: ["MaxFileUploadSize(MB)", "AllowedFileTypes"],
};
